import HeaderAbout from '../../components/sections/HeaderAbout'
import Bio from '../../components/sections/Bio'
import PartitionBee from '../../components/PartitionBee'
import FAQs from '../../components/sections/FAQs'
import './about.css'

const About = () => {
  return (
    <>
      <HeaderAbout />
      <Bio />
      <PartitionBee sectionAbove="bio" skin="dark" />
      <FAQs />
    </>
  )
}

export default About